import Vue from 'vue';
import Vuex from 'vuex';
import VueXAlong from 'vuex-along'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isInPC: true,
    isInMobile: false,
    windowWidth: 0,
    scrollBarTop: 0,
    scrollBarHeight: 0,
    isTeaching: false,
    IsInterview: false,
    userinfo: {},
    timer:'',
    isLogin: false,
    isVisible:false,
    fileConfigs: [],
    permitList: [],
    chatRecords: [],
    qiniuTime:'',
    mysqlTime:'',
    hxSave:{},
    istime: false,  // 环信存储计时器是否开启
    txt:'',  // 环信存储txt
    activityObej:{},// 活动
    user:{},
  },
  mutations: {
    updateWindowWidth(state, val) {
      state.windowWidth = val;
      if (val >= 750) {
        state.isInPC = true;
        state.isInMobile = false;
      } else {
        state.isInPC = false;
        state.isInMobile = true;
      }
    },
    updateScrollBarTop(state, val) {
      state.scrollBarTop = val;
    },
    updateScrollBarHeight(state, val) {
      state.scrollBarHeight = val;
    },
    //全局弹窗
    updateVisible(state, val) {
      state.isVisible = val;
    },
    //上课
    updateIsTeaching(state, val) {
      state.isTeaching = val;
    },
    //访谈
    updateIsInterview(state, val) {
      state.IsInterview = val;
    },
    //删除上课
    updateTimer(state,val){
      state.timer = val
    },
    updateUserinfo(state, val) {
      state.userinfo = val;
      state.isLogin = Object.keys(val).length > 0;
    },
    updateUser(state,val){
      state.user=val
    },
    updateFileConfigs(state, val) {
      state.fileConfigs = val;
    },
    updatePermitList(state, val) {
      state.permitList = val;
    },
    updateChatRecords(state, val) {
      state.chatRecords = val;
    },
    updateQiniuTime(state,val) {
      state.qiniuTime = val;
    },
    updateHxSave(state,val) {
      state.hxSave = val
    },
    updateMysqlTime(state,val) {
      state.mysqlTime = val;
    },
    updateTime(state,val) {
      state.istime = val;
    },
    updateTxt(state,val) {
      state.txt = val;
    },
    updateActivity(state, val) {
      state.activityObej = val;
    },

  },
  plugins: [VueXAlong({
    name: 'along',     //存放在localStroage或者sessionStroage 中的名字
    local: false,      //是否存放在local中  false 不存放 如果存放按照下面session的配置配
    session: { list: [], isFilter: true }   
    //如果值不为false 那么可以传递对象 其中 当isFilter设置为true时， list 数组中的值就会被过滤调,这些值不会存放在seesion或者local中
  })]


});
